import { useMemo, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { ActionSelections } from '../../../core/types/chat.types'
import FlowActionInlineForm from './flow-action-inline-form'

type FlowActionBudgetFreeTextFormProps = {
  title: string
  label?: string
  placeholder?: string
  onCancel: () => void
  onApply: (selections: ActionSelections) => void
}

const useStyles = makeStyles((theme) => ({
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  label: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: 'var(--ds-fg-secondary, #535b6c)',
  },
  textarea: {
    width: '100%',
    minHeight: 90,
    resize: 'vertical',
    borderRadius: 10,
    border: '1px solid var(--ds-border-default, #d7dae4)',
    background: 'var(--ds-bg-surface, #ffffff)',
    color: 'var(--ds-fg-primary, #1f2430)',
    padding: theme.spacing(1.25, 1.5),
    fontSize: '0.875rem',
    lineHeight: 1.5,
    outline: 'none',
    boxSizing: 'border-box',
  },
  counter: {
    fontSize: '0.75rem',
    color: 'var(--ds-fg-secondary, #535b6c)',
    textAlign: 'right',
  },
}))

const FlowActionBudgetFreeTextForm = ({
  title,
  label = 'Describe the changes',
  placeholder = 'Enter line item modifications...',
  onCancel,
  onApply,
}: FlowActionBudgetFreeTextFormProps) => {
  const classes = useStyles()
  const [inputText, setInputText] = useState('')
  const trimmedText = useMemo(() => inputText.trim(), [inputText])

  return (
    <FlowActionInlineForm
      title={title}
      canApply={trimmedText.length > 0}
      onCancel={onCancel}
      onApply={() => {
        if (!trimmedText) {
          return
        }

        onApply({
          budgetPrompt: trimmedText,
        })
      }}
    >
      <div className={classes.field}>
        <label className={classes.label} htmlFor="flow-budget-free-text">
          {label}
        </label>
        <textarea
          id="flow-budget-free-text"
          className={classes.textarea}
          rows={3}
          maxLength={120}
          placeholder={placeholder}
          value={inputText}
          onChange={(event) => setInputText(event.target.value)}
        />
        <div className={classes.counter}>{inputText.length}/120</div>
      </div>
    </FlowActionInlineForm>
  )
}

export default FlowActionBudgetFreeTextForm
